"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.version="6.0.0-beta.0";